import { useTranslation } from "react-i18next";
import { classNames } from "../../Utils";

const FormLabel = ({ htmlFor, label, required, className }) => {
  const { t } = useTranslation();
  const isRequired = required ? (
    <span className="text-red-500">*</span>
  ) : (
    <span className="text-slate-400 font-normal text-xs ml-1">{t("(Optional)")}</span>
  );

  return (
    <label
      htmlFor={htmlFor}
      className={classNames(
        className,
        "block text-sm font-semibold text-slate-700"
      )}
    >
      {label} {isRequired}
    </label>
  );
};

export default FormLabel;
